export default __webpack_public_path__ + "static/media/mobile-crowd.4e0896bd.svg";